// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73a369e1","667":"286d4f06"}[chunkId] + ".chunk.js";
};